export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader_zp_250x250.ed9e087b.gif";